import React from "react";
import {EstimationData} from "../../../api/types";

export default React.createContext<EstimationData>(null);
